import React from 'react'
import HeatMap from "./HeatMaps"
import TableComponent from './TableComponent'

const ProjectPage= () => {
  const positions = [
    "top-10 right-48",
    "top-[230px] right-[360px]",
    "top-[320px] right-[560px]",
    "top-[420px] right-[410px]",
    "bottom-[450px] left-[480px]",
    "bottom-[500px] right-[160px]",
    "bottom-[130px] left-1/3",
    "bottom-[200px] right-[480px]",
  ]

  return (
    <div className='md:px-24 px-4'>
    
      <HeatMap />
  <TableComponent/>
  <div className="flex md:gap-4 gap-1  justify-end md:mt-7 mt-4 md:mb-10 mb-5">
   {/* Edit Button */}
   <div>
        <button className="flex items-center justify-between md:w-[230px] w-[60px] md:h-[41px] h-[20px] bg-[#03897B] text-white md:text-[14px] text-[6px] font-bold rounded-[10px] md:px-4 px-4 ">
          <span>ADD</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746112737/Add_square_tjgwgz.png"
            alt="Edit Icon"
            className="md:w-[28px] h-2  md:h-[28px] w-2 "
          />
        </button>
        <p className='md:text-[14px] text-[5px] md:mt-1  mt-1 font-normal md:px-1 '>
        Add new grower
        </p>
        </div>
        {/* Edit Button */}
        <div>
        <button className="flex items-center justify-between md:w-[230px] w-[60px] md:h-[41px] h-[20px] bg-[#03897B] text-white md:text-[14px] text-[6px] font-bold rounded-[10px] md:px-4 px-4 ">
          <span>EDIT</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
            alt="Edit Icon"
            className="md:w-[25px] h-2  md:h-[28px] w-2 "
          />
        </button>
        <p className='md:text-[14px] text-[5px] md:mt-1  mt-1 font-normal md:px-1 '>
        Edit registration form
        </p>
        </div>


        {/* Save Button */}
    <div>
    <button className="flex items-center justify-between w-[60px] md:w-[230px] h-[20px] md:h-[41px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4">
          <span>SAVE</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690487/Arhive_load_duotone_line_1_hbsukd.png"
            alt="Save Icon"
            className="md:w-[25px] h-2  md:h-[28px] w-2 "
          />
        </button>
        <p className='md:text-[14px]  text-[5px] md:mt-1 mt-1 font-normal md:px-1 '>
        Save registration 
        </p>
    </div>
    <div>
    <button className="flex items-center justify-between w-[60px] md:w-[230px] h-[20px] md:h-[41px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4">
          <span>SEND</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746115722/Send_fill_msz8zu.png"
            alt="Save Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px]  text-[5px] md:mt-1 mt-1 font-normal md:px-1 '>
        Send Due diligence form
        </p>
    </div>
      </div>
<div className='md:h-14 h-3'></div>

    </div>
  )
}

export default ProjectPage
